import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.NOTICE_SET_NOTICE_LIST]: (state, payload) => {
    state.noticeList = payload.noticeList
  }
}

export default Mutations
